// Tiny classnames joiner: keeps truthy parts and returns undefined when empty
// so React omits the class attribute entirely.
export type ClassValue = string | false | null | undefined;

export function cx(...parts: ClassValue[]): string | undefined {
  const joined = parts.filter(Boolean).join(" ");
  return joined || undefined;
}
